export default "__VITE_ASSET__CPzMXlkD__"